import { Collection } from 'modules/core/lib/mobx-rest'
import type { SetOptions } from 'modules/core/lib/mobx-rest/types'

import type { IChange } from 'modules/bookkeepers/store/models/Change'
import Change from 'modules/bookkeepers/store/models/Change'

class Changes extends Collection<Change> {
  incidenceId: number

  constructor(data: Change[], incidenceId: number) {
    super(data)
    this.incidenceId = incidenceId
  }

  get cacheKey(): string {
    return 'changes'
  }

  private get dynamicPath() {
    return `/bookkeepers_management/incidences/${this.incidenceId}/history`
  }

  create(attributes: Partial<IChange>) {
    return super.create(attributes, { path: this.dynamicPath })
  }

  fetch(options: SetOptions = {}) {
    return super.fetch({ ...options, path: this.dynamicPath })
  }

  model() {
    return Change
  }
}

export default Changes
